<template>
  <div>
    <el-row
      class="repeater-row mb-20"
      v-for="(field, index) in fields"
      :key="index"
    >
      <el-col :span="13">
        <el-input-number
          :controls="false"
          v-model="field.value"
          :min="0.5"
          :precision="2"
        />
      </el-col>
      <el-col
        :offset="2"
        :span="2"
      >
        <el-radio
          @change="validateDefaultValue(index)"
          v-model="field.checked"
          :label="true"
        >
          {{ $t('organization.default') }}
        </el-radio>
      </el-col>
      <el-col
        :offset="4"
        :span="3"
      >
        <i
          class="el-icon-circle-plus repeater-row-add"
          @click="addRepeaterField(index)"
        />
        <i
          class="el-icon-remove repeater-row-remove"
          @click="removeRepeaterField(index)"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Repeater',
  props: {
    fields: {
      type: Array,
      default: () => {
        return new Array([{ value: '', checked: false }]);
      }
    },
    max: {
      type: Number,
      default: 4
    },
    prop: {
      type: String,
      default: ''
    }
  },
  methods: {
    addRepeaterField (index) {
      if (this.fields.length < this.max) {
        this.fields.splice(index + 1, 0, ...[{ value: '', checked: false }]);
      } else {
        this.$message.warning(`You can't add more than ${this.max} items`);
      }
    },
    removeRepeaterField (index) {
      if (this.fields.length > 1) {
        this.fields.splice(index, 1);
      } else {
        this.$message.warning('You can\t delete all items');
      }
    },
    validateDefaultValue (index) {
      this.fields.map((el, key) => {
        if (key !== index) {
          el.checked = false;
        }
      });
      this.$emit('change-radio', this.prop);
    }
  }
};
</script>

<style lang="scss" scoped>
.repeater-row {
  &-add, &-remove {
    font-size: 25px;
    cursor: pointer;
    margin-right: 5px;
  }
}
</style>
